import axios from '../../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/order/AOrderStatistics/index",{
        params: {
            ...params
        }
    }  )
}
function GET_DETAIL_LIST(params) {
    return axios.get("/order/AOrderStatistics/getInfo",{
        params: {
            ...params
        }
    }  )
}
function RATE_PIE(params) {
    return  axios.get("/order/AOrderStatistics/RatePie",{
        params: {
            ...params
        }
    }  )
}
// /order/AOrderStatistics/getInfo
export default {
    RATE_PIE,
    GET_DETAIL_LIST,
    GET_LIST,
};
